import { render, staticRenderFns } from "./LiveList.vue?vue&type=template&id=28569d5d&scoped=true&"
import script from "./LiveList.vue?vue&type=script&lang=js&"
export * from "./LiveList.vue?vue&type=script&lang=js&"
import style0 from "./LiveList.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./LiveList.vue?vue&type=style&index=1&id=28569d5d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28569d5d",
  null
  
)

export default component.exports